import { CampaignType, Locale, Page } from 'scripts/type'

const defaultPageTitle = {
  [Locale.ZhCn]: {
    [CampaignType.SURVEY]: '浩客问卷',
    [CampaignType.FEEDBACK]: '浩客评价',
    [CampaignType.REPLY]: '浩客回复',
    [CampaignType.NOTIFICATION]: '浩客通知',
  },
  [Locale.Tw]: {
    [CampaignType.SURVEY]: '浩客問卷',
    [CampaignType.FEEDBACK]: '浩客評價',
    [CampaignType.REPLY]: '浩客廻複',
    [CampaignType.NOTIFICATION]: '浩客通知',
  },
  [Locale.En]: {
    [CampaignType.SURVEY]: 'HowXM Survey',
    [CampaignType.FEEDBACK]: 'HowXM Feedback',
    [CampaignType.REPLY]: 'HowXM Reply',
    [CampaignType.NOTIFICATION]: 'HowXM Notification',
  },
}

export function setPageTitle(page: Page, locale: Locale, type?: CampaignType) {
  const { label, labelHidden } = page.nodes[0] ?? {}
  document.title = label && !labelHidden ? label : defaultPageTitle[locale][type ?? CampaignType.SURVEY]
}
